// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as ErrorReporter$Showside from "./ErrorReporter.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PDPLoadingStencils$StoriesMobilePDPLoading(Props) {
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-2 bg-primary opacity-10 rounded"),
    style: {
      margin: "10px 18px",
      width: "calc(100% - 36px)"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "18px",
      marginLeft: "18px",
      width: "65%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "6px",
      marginLeft: "18px",
      width: "30%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("absolute right-0 top-0 h-6 w-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "38px",
      marginRight: "18px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("absolute left-1/2 bottom-0 transform -translate-x-1/2 bg-primary opacity-10 rounded"),
    style: {
      height: "42px",
      marginBottom: "38px",
      width: "200px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("absolute left-1/2 bottom-0 transform -translate-x-1/2 bg-primary opacity-10 rounded"),
    style: {
      height: "12px",
      marginBottom: "18px",
      width: "80px"
    }
  }));
}
PDPLoadingStencils$StoriesMobilePDPLoading.displayName = "PDPLoadingStencils.StoriesMobilePDPLoading";
var StoriesMobilePDPLoading = {
  make: PDPLoadingStencils$StoriesMobilePDPLoading
};
function PDPLoadingStencils$VerticalDesktopPDPLoading(Props) {
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden p-17")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex w-full")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      width: "80px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      margin: "0 auto",
      width: "120px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      width: "80px"
    }
  })), React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col h-full space-x-13"),
    style: {
      margin: "18px",
      width: "calc(100% - 36px)"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("grid gap-6 grid-cols-2 grid-rows-2 flex-grow"),
    style: {
      height: "80%"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-2 bg-primary opacity-10 rounded")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
  })), React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow"),
    style: {
      marginTop: "36px"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      width: "65%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "10px",
      width: "30%"
    }
  }))));
}
PDPLoadingStencils$VerticalDesktopPDPLoading.displayName = "PDPLoadingStencils.VerticalDesktopPDPLoading";
var VerticalDesktopPDPLoading = {
  make: PDPLoadingStencils$VerticalDesktopPDPLoading
};
function PDPLoadingStencils$HorizontalDesktopPDPLoading(Props) {
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden p-17")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("flex w-full")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      width: "80px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      margin: "0 auto",
      width: "120px"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      width: "80px"
    }
  })), React.createElement("div", {
    className: CSS$Showside.prefix("flex w-full h-full space-x-13"),
    style: {
      marginTop: "18px"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("grid gap-6 grid-cols-2 grid-rows-2 flex-grow"),
    style: {
      width: "50%"
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-2 bg-primary opacity-10 rounded")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
  })), React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "18px",
      marginLeft: "18px",
      width: "65%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "10px",
      marginLeft: "18px",
      width: "30%"
    }
  }))));
}
PDPLoadingStencils$HorizontalDesktopPDPLoading.displayName = "PDPLoadingStencils.HorizontalDesktopPDPLoading";
var HorizontalDesktopPDPLoading = {
  make: PDPLoadingStencils$HorizontalDesktopPDPLoading
};
function PDPLoadingStencils$DesktopPDPLoading(Props) {
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute flex top-0 left-0 w-full h-full bg-main overflow-hidden")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-full bg-primary opacity-10 rounded"),
    style: {
      width: "60%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "18px",
      marginLeft: "18px",
      width: "65%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "10px",
      marginLeft: "18px",
      width: "30%"
    }
  })));
}
PDPLoadingStencils$DesktopPDPLoading.displayName = "PDPLoadingStencils.DesktopPDPLoading";
var DesktopPDPLoading = {
  make: PDPLoadingStencils$DesktopPDPLoading
};
function PDPLoadingStencils$MobilePDPLoading(Props) {
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("w-full bg-primary opacity-10 rounded"),
    style: {
      height: "60%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "18px",
      marginLeft: "18px",
      width: "65%"
    }
  }), React.createElement("div", {
    className: CSS$Showside.prefix("h-6 bg-primary opacity-10 rounded"),
    style: {
      marginTop: "10px",
      marginLeft: "18px",
      width: "30%"
    }
  }));
}
PDPLoadingStencils$MobilePDPLoading.displayName = "PDPLoadingStencils.MobilePDPLoading";
var MobilePDPLoading = {
  make: PDPLoadingStencils$MobilePDPLoading
};
function PDPLoadingStencils(Props) {
  var productId = Props.productId;
  var variantId = Props.variantId;
  var isInsideQuickView = Props.isInsideQuickView;
  var match = EntrypointContext$Showside.use(undefined);
  var onBackClick = match.onBackClick;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var storeId = match$2.transitiveStoreId;
  var settings = match$2.settings;
  var match$3 = ViewportContext$Showside.use(undefined);
  var isMobile = match$3.isMobile;
  var renderStencil = function (param) {
    var match = settings.newMobilePDP;
    var match$1 = settings.desktopPDPLayout;
    var exit = 0;
    if (match) {
      if (isMobile) {
        return React.createElement(PDPLoadingStencils$StoriesMobilePDPLoading, {});
      }
      exit = 2;
    } else {
      exit = 2;
    }
    if (exit === 2) {
      switch (match$1) {
        case /* Old */0:
          break;
        case /* Horizontal */1:
          if (!isMobile && !isInsideQuickView) {
            return React.createElement(PDPLoadingStencils$HorizontalDesktopPDPLoading, {});
          }
          break;
        case /* Vertical */2:
          if (!isMobile && !isInsideQuickView) {
            return React.createElement(PDPLoadingStencils$VerticalDesktopPDPLoading, {});
          }
          break;
      }
    }
    if (isMobile) {
      return React.createElement(PDPLoadingStencils$MobilePDPLoading, {});
    } else {
      return React.createElement(PDPLoadingStencils$DesktopPDPLoading, {});
    }
  };
  var renderAlert = function (param) {
    return React.createElement(ConditionalRender$Showside.Delayed.make, {
      delayMs: 5000,
      children: React.createElement(ErrorReporter$Showside.make, {
        error: RollbarInstance$Showside.makeError(true, "Failed to render PDP: timed out after 5s"),
        extraInfo: {
          requestedStoreId: storeId,
          requestedProductId: productId,
          requestedVariantId: variantId
        },
        redirect: onBackClick
      })
    });
  };
  return React.createElement(React.Fragment, undefined, renderStencil(undefined), renderAlert(undefined));
}
PDPLoadingStencils.displayName = "PDPLoadingStencils";
var make = PDPLoadingStencils;
export { StoriesMobilePDPLoading, VerticalDesktopPDPLoading, HorizontalDesktopPDPLoading, DesktopPDPLoading, MobilePDPLoading, make };
/* react Not a pure module */